/* variant-fix.js
   Ensures the selected variant id is propagated into any form input[name="id"]
   and protects the add-to-cart submit so the correct variant gets added.
   Safe, small, and passive — mirror of console-proved snippet.
*/
(function(){
  function productContainerFrom(el){
    return el && el.closest && (el.closest('.product__details') || el.closest('.product-form') || el.closest('[data-product-url]')) || document.querySelector('.product__details') || document.querySelector('.product-form') || document.querySelector('[data-product-url]');
  }
  function readSelectedVariantIdFromDom(container){
    container = container || document;
    const pref = container.querySelector('input#selected-variant-id, input#selected-variant-id[id], input[name="id"][id="selected-variant-id"]');
    if(pref && pref.value) return pref.value;
    const ids = Array.from(container.querySelectorAll('input[name="id"]')).map(i => i.value).filter(Boolean);
    if(ids.length) return ids[0];
    if(window.__vc_selectedVariantId) return window.__vc_selectedVariantId;
    return null;
  }
  function copySelectedIntoAll(productContainer){
    const vid = readSelectedVariantIdFromDom(productContainer);
    if(!vid) return;
    Array.from((productContainer || document).querySelectorAll('input[name="id"]')).forEach(i=>{
      i.value = vid;
    });
    const s = (productContainer || document).querySelector('#selected-variant-id');
    if(s) s.value = vid;
    // debug: remove/comment out in production if noisy
    // console.log('[variant-fix] propagated id ->', vid);
  }
  function watchProduct(container){
    if(!container) return;
    setTimeout(()=>copySelectedIntoAll(container), 50);
    const obs = new MutationObserver((mutList)=>{
      if(obs._timeout) clearTimeout(obs._timeout);
      obs._timeout = setTimeout(()=>{ copySelectedIntoAll(container); }, 40);
    });
    obs.observe(container, { childList:true, subtree:true, attributes:true, attributeFilter:['value'] });
    container.addEventListener('change', (ev)=>{
      if(ev.target && (ev.target.tagName === 'SELECT' || ev.target.name === 'id')) copySelectedIntoAll(container);
    }, true);
    return obs;
  }
  function installSubmitInterceptor(){
    document.addEventListener('submit', function(ev){
      try{
        const form = ev.target;
        if(!(form && form.matches && form.matches('form[action$="/cart/add"], form'))) return;
        const container = productContainerFrom(form);
        const vid = readSelectedVariantIdFromDom(container) || readSelectedVariantIdFromDom(document);
        if(vid){
          let input = form.querySelector('input[name="id"]');
          if(!input){
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'id';
            form.appendChild(input);
          }
          input.value = vid;
          // console.log('[variant-fix] submit: ensured form id =', vid);
        }
      }catch(err){ console.error('[variant-fix] submit interceptor error', err); }
    }, true);
  }
  const productWrappers = Array.from(document.querySelectorAll('.product__details, .product-form, [data-product-url]'));
  if(productWrappers.length === 0) productWrappers.push(document.body);
  productWrappers.forEach(w => watchProduct(w));
  installSubmitInterceptor();
  // console.log('[variant-fix] installed. Watching product wrappers:', productWrappers.length);
})();
